import React from "react";

export default function NoApplication() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="84.92"
      height="106.15"
      viewBox="0 0 84.92 106.15"
    >
      <g id="curriculum" transform="translate(-51.2)" opacity="0.5">
        <g id="Group_2010" data-name="Group 2010" transform="translate(114.89)">
          <g id="Group_2009" data-name="Group 2009">
            <path
              id="Path_52"
              data-name="Path 52"
              d="M358.4,0V21.23h21.23Z"
              transform="translate(-358.4)"
              fill="#a9afbc"
            />
          </g>
        </g>
        <g id="Group_2012" data-name="Group 2012" transform="translate(51.2)">
          <g id="Group_2011" data-name="Group 2011" transform="translate(0)">
            <path
              id="Path_53"
              data-name="Path 53"
              d="M104.275,31.845V0H56.507A5.014,5.014,0,0,0,51.2,5.308v95.535a5.014,5.014,0,0,0,5.307,5.308h74.305a5.014,5.014,0,0,0,5.307-5.308v-69ZM77.738,10.615A10.615,10.615,0,1,1,67.122,21.23,10.646,10.646,0,0,1,77.738,10.615ZM61.815,45.645c0-11.146,31.845-11.146,31.845,0v7.431H61.815Zm47.767,49.89H67.122a5.307,5.307,0,0,1,0-10.615h42.46a5.014,5.014,0,0,1,5.308,5.308A5.319,5.319,0,0,1,109.582,95.535ZM120.2,74.305H67.122a5.308,5.308,0,0,1,0-10.615H120.2A5.014,5.014,0,0,1,125.505,69,5.319,5.319,0,0,1,120.2,74.305Z"
              transform="translate(-51.2)"
              fill="#a9afbc"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
